export default {
  'es-ES': {
    LOADING: 'Traveller Stories',
    MORE_STORIES: 'Tenemos mas historias para ti',
    OF: 'de',
    READING_TIME_PRE: 'Lectura de ',
    READING_TIME_POST: "'",
    SHARE: 'Comparte',
    SHARE_CAPTION: 'Compártelo con tus seguidores y acércales un poco más al universo viajero',
  },

  'en-EN': {
    LOADING: 'Traveller Stories',
    MORE_STORIES: 'We have more stories for you',
    OF: 'of',
    READING_TIME_PRE: '',
    READING_TIME_POST: "' reading",
    SHARE: 'Share',
    SHARE_CAPTION: 'Share with your friends and make the travel world just a little bit bigger',
  },

  'en-GB': {
    LOADING: 'Traveller Stories',
    MORE_STORIES: 'We have more stories for you',
    OF: 'of',
    READING_TIME_PRE: '',
    READING_TIME_POST: "' reading",
    SHARE: 'Share',
    SHARE_CAPTION: 'Share with your friends and make the travel world just a little bit bigger',
  },

  'pt-PT': {
    LOADING: 'Traveller Stories',
    MORE_STORIES: 'Mais Stories',
    OF: 'de',
    READING_TIME_PRE: '',
    READING_TIME_POST: '',
    SHARE: 'Partilhar',
    SHARE_CAPTION: 'Aproxime-os um pouco mais do maravilhoso mundo das viagens',
  },

  'it-IT': {
    LOADING: 'Traveller Stories',
    MORE_STORIES: 'Altre Stories',
    OF: 'di',
    READING_TIME_PRE: 'Lettura di',
    READING_TIME_POST: '',
    SHARE: 'Condividi',
    SHARE_CAPTION: 'Condividi con i tuoi amici e rendi il mondo dei viaggi un pochino più grande',
  },

  'fr-FR': {
    LOADING: 'Traveller Stories',
    MORE_STORIES: 'Plus de Stories',
    OF: 'de',
    READING_TIME_PRE: 'Lecture de',
    READING_TIME_POST: '',
    SHARE: 'Partager',
    SHARE_CAPTION: 'Partagez avec vos amis et agrandissez un peu plus la communauté des voyageurs',
  },
};
